import { apm } from '@elastic/apm-rum';

import broadcastLogoutChannel from '../modules/Session/broadcastLogoutChannel';
import { ErrorCode } from './constants';

let isLoggingOut = false;

interface ErrorResponse {
  code?: string;
  message?: string;
}

/**
 * Handle auth errors by redirecting to logout.
 * API returns { code: "USER_NOT_AUTHORIZED", error: { code: "UNAUTHORIZED" } }
 *
 * Returns true if logout was triggered (caller should suppress error propagation),
 * false otherwise (caller should propagate error normally).
 */
export const handleAuthError = (
  status?: number,
  errorData?: ErrorResponse
): boolean => {
  try {
    // Check for UNAUTHORIZED errors (e.g., soft-deleted users)
    const errorCode = errorData?.code;
    const isUnauthorized = errorCode === ErrorCode.UNAUTHORIZED;

    if (!isUnauthorized) return false;

    // if we are already on the logout page, or another logout has started,
    // don't trigger another navigation but still suppress the error
    if (window.location.pathname.startsWith('/logout') || isLoggingOut)
      return true;

    isLoggingOut = true;
    broadcastLogoutChannel();

    // use replace so we don't leave a history entry that could cause
    // navigation loops when the page reloads
    window.location.replace('/logout?clearSiteStorage');
    return true;
  } catch (e) {
    const errorMessage = `Error in handleAuthError: ${(e as Error).message}`;
    apm.captureError(errorMessage);
    return false;
  }
};
